import React from "react";

const NODES = [
  { id: "kashmir", x: 210, y: 60, type: "renewable", name: "Kashmir" },

  { id: "delhi", x: 193, y: 173, type: "biofuel", name: "Delhi NCR" },
  { id: "mumbai", x: 102, y: 395, type: "ev", name: "Mumbai", labelDx: -8, labelAnchor: "end" },
  { id: "kolkata", x: 428, y: 314, type: "renewable", name: "Kolkata" },
  { id: "chennai", x: 258, y: 536, type: "ev", name: "Chennai", labelDy: 16 },
  { id: "bangalore", x: 201, y: 538, type: "biofuel", name: "Bengaluru", labelDx: -8, labelAnchor: "end" },
  { id: "hyderabad", x: 220, y: 435, type: "ev", name: "Hyderabad" },
  { id: "ahmedabad", x: 96, y: 303, type: "renewable", name: "Ahmedabad", labelDx: -8, labelAnchor: "end" },
  { id: "pune", x: 123, y: 408, type: "biofuel", name: "Pune", labelDx: -8, labelAnchor: "end", labelDy: 12 },
  { id: "jaipur", x: 164, y: 212, type: "renewable", name: "Jaipur", labelDx: -8, labelAnchor: "end" },
  { id: "lucknow", x: 272, y: 214, type: "biofuel", name: "Lucknow" },
  { id: "bhopal", x: 198, y: 298, type: "ev", name: "Bhopal", labelDy: 16 },
  { id: "kochi", x: 174, y: 609, type: "renewable", name: "Kochi", labelDx: -8, labelAnchor: "end" },
  { id: "kanyakumari", x: 245, y: 640, type: "ev", name: "Kanyakumari" },
  { id: "guwahati", x: 499, y: 230, type: "biofuel", name: "Guwahati" },
  { id: "chandigarh", x: 184, y: 123, type: "ev", name: "Chandigarh", labelDx: -8, labelAnchor: "end" },
];

const COLOR = {
  biofuel: "#138808",
  ev: "#FF9933",
  renewable: "#4FB3FF",
};

const CONNECTIONS = [
  ["kashmir", "chandigarh"],
  ["delhi", "jaipur"], ["delhi", "lucknow"], ["delhi", "chandigarh"],
  ["jaipur", "ahmedabad"], ["ahmedabad", "mumbai"], ["mumbai", "pune"],
  ["pune", "hyderabad"], ["hyderabad", "bangalore"], ["bangalore", "chennai"],
  ["chennai", "kochi"], ["kochi", "kanyakumari"],
  ["hyderabad", "bhopal"], ["bhopal", "lucknow"],
  ["lucknow", "kolkata"], ["kolkata", "guwahati"],
  ["delhi", "bhopal"], ["bangalore", "kochi"],
];

const findNode = (id) => NODES.find((n) => n.id === id);

export default function IndiaMap() {
  return (
    <svg
      viewBox="0 0 609 666"
      className="india-map-svg w-full h-auto"
      role="img"
      aria-label="Projected Indian Eco Fuels network map across India"
    >
      <defs>
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <style>{`
          .flow-line {
            stroke-dasharray: 6 10;
            animation: flow 2.8s linear infinite;
          }

          @keyframes flow {
            from { stroke-dashoffset: 0; }
            to { stroke-dashoffset: -200; }
          }

          .node-blink {
            animation: blink 1.8s ease-in-out infinite;
          }

          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.35; }
          }

          .hover-3d {
            transition: transform 0.35s ease;
          }

          .hover-3d:hover {
            transform: translateY(-3px) scale(1.05);
            filter: drop-shadow(0 10px 18px rgba(0,0,0,0.35));
          }
        `}</style>
      </defs>

      <rect
        x="20"
        y="18"
        width="569"
        height="630"
        rx="28"
        className="india-map-backdrop"
      />

      {/* Base Map */}
      <image
        href="/india_outline.png"
        x="0"
        y="0"
        width="609"
        height="666"
        className="india-map-outline"
      />

      {/* Connections */}
      {CONNECTIONS.map(([a, b], i) => {
        const A = findNode(a);
        const B = findNode(b);
        if (!A || !B) return null;

        return (
          <line
            key={i}
            x1={A.x}
            y1={A.y}
            x2={B.x}
            y2={B.y}
            stroke="#138808"
            strokeWidth="1.2"
            className="flow-line india-map-line"
            style={{ animationDelay: `${i * 0.12}s` }}
          />
        );
      })}

      {/* Nodes */}
      {NODES.map((n) => {
        const dx = n.labelDx ?? 11;
        const dy = n.labelDy ?? 4;
        const anchor = n.labelAnchor ?? "start";

        return (
          <g key={n.id} className="hover-3d" filter="url(#glow)">
            
            {/* ONLY BLINKING CORE DOT (clean version) */}
            <circle
              cx={n.x}
              cy={n.y}
              r="4"
              fill={COLOR[n.type]}
              className="node-blink"
            />

            {/* Label */}
            <text
              x={n.x + dx}
              y={n.y + dy}
              fontSize="11"
              className="india-map-label"
              fontFamily="monospace"
              textAnchor={anchor}
            >
              {n.name}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
